import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
         <p> © 2020 Bar Hopper. Made by Gureje kolade, Carlos Cesar Valle and Christina Rice </p>
    
            
        </div>
    );
};

export default Footer;